import React from "react";

const DEFAULT_BANNER = '/defaults/default-banner.svg';
const handleImgError = (e) => { e.target.onerror = null; e.target.src = DEFAULT_BANNER; };

function ContactBanner({ sliderContact = [], globalData = {} }) {
  const origin = window.location.origin.replace(/^https?:\/\/(aff\.)?/, '');

  return (
    <div className="et-l et-l--body">
      <div className="et_builder_inner_content et_pb_gutters3">
        <div className="et_pb_section et_pb_section_0_tb_body et_section_regular">
          <div className="et_pb_row et_pb_row_0_tb_body">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_0_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_text et_pb_text_0_tb_body et_pb_text_align_center et_pb_bg_layout_light">
                <div className="et_pb_text_inner">
                  <h1>Contact Us</h1>
                  <p>Get in touch with our affiliate support team</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="et_pb_section et_pb_section_1_tb_body et_section_regular">
          <div className="et_pb_row et_pb_row_1_tb_body et_pb_equal_columns">
            <div className="et_pb_column et_pb_column_1_2 et_pb_column_0_tb_body et_pb_css_mix_blend_mode_passthrough">
              <div className="et_pb_module et_pb_blurb et_pb_text_align_left et_pb_bg_layout_light">
                <div className="et_pb_blurb_content">
                  <div className="et_pb_blurb_container">
                    <h2 className="et_pb_module_header"><span><i className="fas fa-envelope" style={{ marginRight: '10px' }}></i>Email</span></h2>
                    <div className="et_pb_blurb_description">
                      <p><a href={`mailto:affiliates@${origin}`}>affiliates@{origin}</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="et_pb_column et_pb_column_1_2 et_pb_column_1_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_blurb et_pb_text_align_left et_pb_bg_layout_light">
                <div className="et_pb_blurb_content">
                  <div className="et_pb_blurb_container">
                    <h2 className="et_pb_module_header"><span><i className="fab fa-telegram" style={{ marginRight: '10px' }}></i>Telegram</span></h2>
                    <div className="et_pb_blurb_description">
                      {globalData?.socialLinks?.telegram && (
                        <p><a href={globalData.socialLinks.telegram} target="_blank" rel="noopener noreferrer">Join our Telegram</a></p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {sliderContact.length > 0 && (
          <div className="et_pb_section et_pb_section_2_tb_body et_section_regular">
            <div className="et_pb_row et_pb_row_2_tb_body">
              <div className="et_pb_column et_pb_column_4_4 et_pb_column_2_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
                {sliderContact.map((item, i) => {
                  const imgPath = item.thumbnail || item.thubmnail;
                  return (
                    <div key={i} style={{ marginBottom: '20px', textAlign: 'center' }}>
                      {imgPath ? (
                        <img decoding="async" src={`${process.env.REACT_APP_API_URL}/storage/${imgPath}`} alt={item.name || ''} style={{ maxWidth: '100%', borderRadius: '10px' }} onError={handleImgError} />
                      ) : (
                        <img decoding="async" src={DEFAULT_BANNER} alt={item.name || 'Contact'} style={{ maxWidth: '100%', borderRadius: '10px' }} />
                      )}
                      {item.name && <h3 className="yellow-color" style={{ marginTop: '15px' }}>{item.name}</h3>}
                      {item.link && <div dangerouslySetInnerHTML={{ __html: item.link }} />}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ContactBanner;
